import { render, staticRenderFns } from "./BatteryDetail.vue?vue&type=template&id=62c7e81f&scoped=true"
import script from "./BatteryDetail.vue?vue&type=script&lang=js"
export * from "./BatteryDetail.vue?vue&type=script&lang=js"
import style0 from "./BatteryDetail.vue?vue&type=style&index=0&id=62c7e81f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c7e81f",
  null
  
)

export default component.exports